// 跨域登陆，同时登陆wujiebantu
export function crossLogin(token: string, backUrl?: string) {
  window.location.href = `${
    process.env.NEXT_PUBLIC_WUJIEBANTU_HOST
  }/api/cross-login?token=${token}&redirect=${encodeURIComponent(
    !!backUrl ? window.location.origin + backUrl : window.location.href
  )}`
}
